export default [
  {
    path: '/news-manage',
    name: 'news-manage',
    component: resolve => require(['views/news-manage'], resolve),
    meta: { auth: true, view: 'pc' }
  },
  {
    path: '/news-manage/news-form/:id/:isEdit',
    props: true,
    name: 'news-form',
    component: resolve => require(['views/news-form'], resolve),
    meta: { auth: true, view: 'pc', navInfo: '新闻管理/新闻', isForm: true }
  },
  {
    path: '/news-manage/news-detail/:id',
    props: true,
    name: 'news-detail',
    component: resolve => require(['views/news-detail'], resolve),
    meta: { auth: true, view: 'pc', navInfo: '新闻管理/新闻详情' }
  },
  {
    path: '/news-manage/news-classify',
    name: 'news-classify',
    component: resolve => require(['views/news-classify'], resolve),
    meta: { auth: true, view: 'pc', navInfo: '新闻管理/新闻分类' }
  },
  {
    path: '/news-manage/news-classify-form/:id/:isEdit',
    props: true,
    name: 'news-classify-form',
    component: resolve => require(['views/news-classify-form'], resolve),
    meta: { auth: true, view: 'pc', navInfo: '新闻管理/新闻分类', isForm: true }
  },
  {
    path: '/notice-manage',
    name: 'notice-manage',
    component: resolve => require(['views/notice-manage'], resolve),
    meta: { auth: true, view: 'pc' }
  },
  {
    path: '/notice-manage/notice-form/:isEdit/:id',
    name: 'notice-form',
    props: true,
    component: resolve => require(['views/notice-form'], resolve),
    meta: { auth: true, view: 'pc', navInfo: '消息管理/发布消息' }
  },
  {
    path: '/notice-manage/notice-detail/:id',
    name: 'notice-detail',
    props: true,
    component: resolve => require(['views/notice-detail'], resolve),
    meta: { auth: true, view: 'pc', navInfo: '消息管理/消息详情' }
  }
]
